function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Icon } from '@unite-us/ui';
import React, { useState, useEffect, useRef } from 'react';
import Skeleton from 'react-loading-skeleton';
import { get, isEmpty, includes, isEqual, some, values } from 'lodash';
import { useNavigate } from 'react-router-dom';
import StepHeader from '../../components/StepHeader';
import { READY_TO_SUMBIT_INFO_TEXT, REVIEW_REFERRAL_DESCRIPTION, CONSENT_DESCRIPTION, CONSENT_COMPLETED, REVIEW_LOADING_SCREEN_DESCRIPTION } from './constants';
import ReferralsSent from './ReferralsSent';
import NoReferralsDisplay from '../builder/NoReferralsDisplay';
import { setData, useAppCreateReferralContext } from '../../context/AppCreateReferralProvider';
import DeleteReferralModal from './DeleteReferralModal';
import NavButtons from '../../components/NavButtons';
import CreateReferralContainer from '../../components/CreateReferralContainer';
import ReferralAuthorizationRequestSummary from '../../components/service_authorization/ReferralAuthorizationRequestSummary';
import useCreateReferrals from '../../hooks/useCreateReferrals';
import { CALLBACKS, COMPONENTS, APP_ENVIRONMENT } from '../../api/config';
import FilePreviewWrapper from '../../common/form/FileUploadV2/components/FilePreviewWrapper';
import useCreateShareEvent from '../../hooks/useCreateShareEvent';
import DocumentsListView from '../../common/form/DocumentUploader/components/DocumentsListView';
import { hasOffPlatformReferrals, isEmptyErrors, referralIsOON } from '../builder/utils';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import { formatShortDate2FromTimestamp } from '../../components/service_authorization/formatShortDate';
import useForwardReferral from '../../hooks/useForwardReferral';
import DropdownMultiplesReferrals from './DropdownMultiplesReferrals';
export default function Review() {
  var navigate = useNavigate();
  var _useAppCreateReferral = useAppCreateReferralContext(),
    dispatch = _useAppCreateReferral.dispatch,
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    fieldsConfig = _useAppCreateReferral2.fieldsConfig,
    referrals = _useAppCreateReferral2.referrals,
    person = _useAppCreateReferral2.person,
    resourceListId = _useAppCreateReferral2.resourceListId,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    caseId = _useAppCreateReferral2.caseId,
    referralId = _useAppCreateReferral2.referralId,
    referralType = _useAppCreateReferral2.referralType,
    serviceTypeName = _useAppCreateReferral2.serviceTypeName;
  var crtb824AddOpenCloseDateOffPlatformCase = useFeatureFlag('crtb824AddOpenCloseDateOffPlatformCase', false);
  var crtb854ForwardingSuperset = useFeatureFlag('crtb854ForwardingSuperset', false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sent = _useState2[0],
    updateSent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSuccessfullyForwarded = _useState4[0],
    setIsSuccessfullyForwarded = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    fieldErrors = _useState6[0],
    setFieldErrors = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    expandedReferrals = _useState8[0],
    setExpandedReferrals = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    deleteReferralModalIsOpen = _useState10[0],
    setDeleteReferralModalIsOpen = _useState10[1];
  var _useState11 = useState(-1),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedReferralToDelete = _useState12[0],
    setSelectedReferralToDelete = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedReferralToLink = _useState14[0],
    setSelectedReferralToLink = _useState14[1];
  // initialize with consent=true to permit ability to send referrals,
  // then redefine on submit to person's actual consent value to (possibly) show consent form.
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    consented = _useState16[0],
    setConsented = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    disableSubmit = _useState18[0],
    setDisableSubmit = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    loading = _useState20[0],
    setLoading = _useState20[1];
  var formRefs = useRef({});
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    referralsResultDetail = _useState22[0],
    setReferralsResultDetail = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    hasBeenSubmitted = _useState24[0],
    setHasBeenSubmitted = _useState24[1];
  var createShareEvent = useCreateShareEvent();
  var isForwardReferralPath = !!referralId && !!referralType;
  var referralSentSuccessfully = sent || isSuccessfullyForwarded;
  var errors = Object.keys(fieldErrors).reduce(function (acc, index) {
    var fieldError = fieldErrors[index];
    acc[index] = {
      referralSelected: fieldError === null || fieldError === void 0 ? void 0 : fieldError.referralSelected
    };
    return acc;
  }, {});
  var hasMultipleReferrals = function hasMultipleReferrals() {
    return referrals.length > 1;
  };
  var setReferralErrors = function setReferralErrors(referralIndex, newErrors) {
    setFieldErrors(function (prevFieldErrors) {
      var currentErrors = prevFieldErrors[referralIndex];
      var updatedErrors = _objectSpread(_objectSpread({}, currentErrors), newErrors);
      if (isEqual(updatedErrors, currentErrors)) {
        return prevFieldErrors;
      }
      return _objectSpread(_objectSpread({}, prevFieldErrors), {}, _defineProperty({}, referralIndex, updatedErrors));
    });
  };
  var isAuthorizationWorkflowEnabled = useFeatureFlag('pays3551AuthInSuperset', false);
  var onChevronClick = function onChevronClick(index) {
    var expanded = expandedReferrals === null || expandedReferrals === void 0 ? void 0 : expandedReferrals.map(function (ref) {
      if (ref.index === index) {
        ref.expanded = !ref.expanded;
      }
      return ref;
    });
    setExpandedReferrals(expanded);
  };
  var onDeleteReferralClick = function onDeleteReferralClick(index) {
    setSelectedReferralToDelete(index);
    setDeleteReferralModalIsOpen(true);
  };
  var onCloseDeleteReferralModal = function onCloseDeleteReferralModal() {
    setDeleteReferralModalIsOpen(false);
  };
  useEffect(function () {
    var expanded = referrals === null || referrals === void 0 ? void 0 : referrals.map(function (r, i) {
      return _objectSpread(_objectSpread({}, r), {}, {
        attachedDocuments: r.attachableDocuments ? r.attachableDocuments.filter(function (doc) {
          return doc.attached;
        }) : [],
        expanded: true,
        index: i
      });
    });
    setExpandedReferrals(expanded);
  }, [referrals]);
  var deleteModal = useRef([]);
  useEffect(function () {
    if (!isEmpty(referrals)) {
      if (deleteReferralModalIsOpen) {
        deleteModal.current[selectedReferralToDelete].openDialog();
      } else if (selectedReferralToDelete >= 0) {
        deleteModal.current[selectedReferralToDelete].closeDialog();
        setSelectedReferralToDelete(-1);
      }
    }
  }, [deleteReferralModalIsOpen, selectedReferralToDelete, referrals]);
  var deleteSelectedReferral = function deleteSelectedReferral() {
    var updatedReferrals = referrals.filter(function (r, i) {
      return i !== selectedReferralToDelete;
    });
    dispatch(setData({
      referrals: _toConsumableArray(updatedReferrals)
    }));
    onCloseDeleteReferralModal();
  };
  var createReferrals = useCreateReferrals();
  var forwardReferral = useForwardReferral();
  var handleSaveDraftReferral = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var onSaveDraftReferral;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return createReferrals({
              draft: true
            });
          case 3:
            onSaveDraftReferral = CALLBACKS.onSaveDraftReferral;
            onSaveDraftReferral && onSaveDraftReferral();
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function handleSaveDraftReferral() {
      return _ref.apply(this, arguments);
    };
  }();
  var setFocus = function setFocus(index) {
    setTimeout(function () {
      var _errors$index;
      if ((_errors$index = errors[index]) !== null && _errors$index !== void 0 && _errors$index.referralSelected) {
        var _formRefs$current;
        (_formRefs$current = formRefs.current) === null || _formRefs$current === void 0 || (_formRefs$current = _formRefs$current.mutators) === null || _formRefs$current === void 0 || _formRefs$current.setFieldTouched('referralSelected', true);
        var referralSelectedField = document.getElementById("referralSelected");
        return referralSelectedField.focus();
      }
    }, 100);
  };
  var focusErrors = function focusErrors() {
    var index = 0;
    var firstIndexWithErrors = Object.keys(errors).find(function (idx) {
      return some(values(errors[idx]), Boolean);
    });
    if (!some(values(errors[index]), Boolean) && firstIndexWithErrors) {
      index = parseInt(firstIndexWithErrors);
    }
    setFocus(index);
  };
  var showReferralsNotifications = function showReferralsNotifications(referralResponses) {
    var amountOfReferralsSent = referralResponses.filter(function (_ref2) {
      var sent = _ref2.sent;
      return sent;
    }).length;
    var totalReferrals = referralResponses.length;
    if (amountOfReferralsSent === totalReferrals) {
      CALLBACKS.notify.success('Referrals created');
    } else if (amountOfReferralsSent > 0) {
      CALLBACKS.notify.warn('Some referrals created');
    } else {
      CALLBACKS.notify.error('No referrals created');
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _referrals$selectedRe, referralToForward, hasBeenForwarded, detail, referralForwardedDeleted, response, _person$consent, _response, _detail;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isEmptyErrors(errors)) {
              _context2.next = 44;
              break;
            }
            setLoading(true);
            setDisableSubmit(true);
            _context2.prev = 3;
            if (!isForwardReferralPath) {
              _context2.next = 23;
              break;
            }
            referralToForward = (_referrals$selectedRe = referrals[selectedReferralToLink]) !== null && _referrals$selectedRe !== void 0 ? _referrals$selectedRe : null;
            _context2.next = 8;
            return forwardReferral({
              caseId: caseId,
              referralToForward: referralToForward
            });
          case 8:
            hasBeenForwarded = _context2.sent;
            detail = [];
            if (!(referrals.length >= 2)) {
              _context2.next = 17;
              break;
            }
            referralForwardedDeleted = referrals.splice(selectedReferralToLink, 1);
            _context2.next = 14;
            return createReferrals();
          case 14:
            response = _context2.sent;
            detail = response.shippingDetail.map(function (item) {
              return {
                index: item.index >= selectedReferralToLink ? item.index + 1 : item.index,
                sent: item.sent
              };
            });
            referrals.splice(selectedReferralToLink, 0, referralForwardedDeleted[0]);
          case 17:
            detail.splice(selectedReferralToLink, 0, {
              index: selectedReferralToLink,
              sent: hasBeenForwarded ? true : false,
              error: hasBeenForwarded ? null : "Unexpected error"
            });
            setIsSuccessfullyForwarded(hasBeenForwarded);
            setReferralsResultDetail(detail);
            showReferralsNotifications(detail);
            _context2.next = 32;
            break;
          case 23:
            _context2.next = 25;
            return createReferrals({
              caseId: caseId
            });
          case 25:
            _response = _context2.sent;
            updateSent(true);
            _detail = _response.shippingDetail.map(function (item) {
              return {
                index: item.index,
                sent: item.sent
              };
            });
            setReferralsResultDetail(_detail);
            showReferralsNotifications(_detail);
            setConsented(((_person$consent = person.consent) === null || _person$consent === void 0 ? void 0 : _person$consent.state) === 'accepted');
            // Create the share event for each referral only if the resource list id is present
            // This is being set from the resource list page or search page before navigating to the create referrals
            if (resourceListId) {
              _response.referrals.map(function (referral) {
                return createShareEvent(referral);
              });
            }
          case 32:
            _context2.next = 38;
            break;
          case 34:
            _context2.prev = 34;
            _context2.t0 = _context2["catch"](3);
            console.error(_context2.t0);
            setDisableSubmit(false);
          case 38:
            _context2.prev = 38;
            setLoading(false);
            setHasBeenSubmitted(true);
            return _context2.finish(38);
          case 42:
            _context2.next = 45;
            break;
          case 44:
            focusErrors();
          case 45:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 34, 38, 42]]);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  // When submitting consent through Consent App
  var onConsentComplete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
      var _event$data;
      var consentAppUrl, eventOrigin, originIsConsentApp;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            consentAppUrl = APP_ENVIRONMENT.consentUrl;
            eventOrigin = get(event, 'origin');
            originIsConsentApp = includes(consentAppUrl, eventOrigin);
            if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.status) === CONSENT_COMPLETED && originIsConsentApp) {
              CALLBACKS.notify.success('Your consent has been recorded.');
              onNavigateAway();
            }
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onConsentComplete(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  // When not submitting consent through Consent App
  var onNavigateAway = function onNavigateAway() {
    CALLBACKS.onSubmitConsent();
    setConsented(true);
  };
  useEffect(function () {
    window.addEventListener('message', onConsentComplete);
    return function () {
      window.removeEventListener('message', onConsentComplete);
    };
  }, []);
  if (referralSentSuccessfully && !consented) {
    var _CALLBACKS$consent;
    var Consent = COMPONENTS.Consent;
    return /*#__PURE__*/React.createElement(CreateReferralContainer, {
      isStepReferralSent: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-12 pb-12"
    }, /*#__PURE__*/React.createElement(StepHeader, {
      header: 'Complete Consent'
    }, CONSENT_DESCRIPTION), /*#__PURE__*/React.createElement(Consent, {
      contact: person,
      currentEmployee: currentEmployee,
      initializedValue: "user_attestation",
      updateGlobalState: CALLBACKS === null || CALLBACKS === void 0 || (_CALLBACKS$consent = CALLBACKS.consent) === null || _CALLBACKS$consent === void 0 ? void 0 : _CALLBACKS$consent.updateGlobalState,
      dialogContentStyles: 'text-validation-red',
      onNavigateAway: onNavigateAway
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(CreateReferralContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "px-12"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base font-proxima font-semibold text-[18px] leading-[28px] text-center mt-5"
  }, REVIEW_LOADING_SCREEN_DESCRIPTION), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-20 bg-white w-full max-w-4xl px-4 md:px-8 lg:px-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center items-center"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 50,
    width: 0.9 * 800,
    style: {
      marginTop: 12
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 20,
    width: 0.9 * 800,
    style: {
      marginTop: 12
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 80,
    width: 0.9 * 800,
    style: {
      marginTop: 12
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-center items-center flex-wrap gap-4 mt-4"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 50,
    width: 0.9 * 394,
    style: {
      marginTop: 12
    }
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 50,
    width: 0.9 * 394,
    style: {
      marginTop: 12
    }
  })))))) : hasBeenSubmitted ? /*#__PURE__*/React.createElement(ReferralsSent, {
    referrals: referrals,
    referralsResultDetail: referralsResultDetail,
    isSuccessfullyForwarded: isSuccessfullyForwarded,
    isForwardReferralPath: isForwardReferralPath
  }) : /*#__PURE__*/React.createElement(CreateReferralContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "px-12"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: true,
    header: 'Review Referrals'
  }, REVIEW_REFERRAL_DESCRIPTION), /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: function onBackClick() {
      return navigate(-1);
    },
    onForwardClick: handleSubmit,
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Confirm & Submit",
    hideForwardButtons: isEmpty(referrals),
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals),
    disabled: disableSubmit,
    isForwardReferralPath: isForwardReferralPath
  }), hasMultipleReferrals() && crtb854ForwardingSuperset && isForwardReferralPath && /*#__PURE__*/React.createElement(DropdownMultiplesReferrals, {
    referrals: referrals,
    setReferralErrors: setReferralErrors,
    formRefs: formRefs,
    setSelectedReferralToLink: setSelectedReferralToLink,
    serviceTypeName: serviceTypeName
  }), isEmpty(referrals) ? /*#__PURE__*/React.createElement(NoReferralsDisplay, {
    onClick: function onClick() {
      return CALLBACKS.onNavigateBack();
    }
  }) : expandedReferrals === null || expandedReferrals === void 0 ? void 0 : expandedReferrals.map(function (referral, index) {
    var programs = referral.programs;
    var isAuthRequired = get(referral, 'programs[0].fee_schedule_program.authorization_required');
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-6 mx-auto responsive-max-width",
      key: "referral-review-card-".concat(index),
      "data-testid": "referral-review-card-".concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-white border border-solid border-blue-border ".concat(referral !== null && referral !== void 0 && referral.expanded ? "rounded-t-lg" : "rounded")
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-6 px-8 flex justify-between"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-black text-grey text-base"
    }, "Referral ", index + 1, ": ", get(referral, 'service.name')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "IconPencil",
      color: "#182A44",
      className: "mr-3",
      onClick: function onClick() {
        return navigate('/create/builder', {
          state: {
            selectedReferral: index
          }
        });
      },
      "data-testid": "referral-review-pencil-".concat(index),
      ariaLabel: "edit"
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: "IconTrash",
      color: "#182A44",
      className: "mr-3",
      onClick: function onClick() {
        return onDeleteReferralClick(index);
      },
      "data-testid": "referral-review-card-trash-".concat(index),
      ariaLabel: "delete"
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: referral !== null && referral !== void 0 && referral.expanded ? "IconChevronDown" : "IconChevronRight",
      color: "#182A44",
      onClick: function onClick() {
        return onChevronClick(index);
      },
      "data-testid": "referral-review-card-chevron-".concat(index),
      ariaLabel: "expand"
    })))), /*#__PURE__*/React.createElement(DeleteReferralModal, {
      refModal: function refModal(el) {
        return deleteModal.current[index] = el;
      },
      onCloseModal: onCloseDeleteReferralModal,
      referral: referral,
      onDeleteSelectedReferral: deleteSelectedReferral
    }), get(referral, 'expanded', true) ? /*#__PURE__*/React.createElement("div", {
      className: "bg-white border border-solid border-blue-border rounded-b-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pt-6 px-8 pb-16"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-span-2 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Referral Programs"), programs.map(function (program, i) {
      return /*#__PURE__*/React.createElement("p", {
        key: i
      }, get(program, 'name'), " ", get(program, 'provider.name') ? '(' + get(program, 'provider.name') + ')' : '');
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-span-1 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Referral Network"), /*#__PURE__*/React.createElement("p", null, get(referral, 'network.name'))), isAuthorizationWorkflowEnabled && get(referral, 'paymentAuthForm') && isAuthRequired && /*#__PURE__*/React.createElement("div", {
      className: "col-span-3 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Authorization Request"), /*#__PURE__*/React.createElement(ReferralAuthorizationRequestSummary, {
      authorizationRequest: get(referral, 'paymentAuthForm'),
      feeScheduleProgram: get(referral, 'programs[0].fee_schedule_program')
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-span-2 mt-10 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Referral Description"), /*#__PURE__*/React.createElement("p", null, get(referral, 'description'))), crtb824AddOpenCloseDateOffPlatformCase && get(referral, 'opened_date') && /*#__PURE__*/React.createElement("div", {
      className: "col-span-1 mt-10 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Open Date"), /*#__PURE__*/React.createElement("p", null, formatShortDate2FromTimestamp(get(referral, 'opened_date'), true))), get(referral, 'primaryWorker.full_name') && /*#__PURE__*/React.createElement("div", {
      className: "col-span-3 mt-10 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Primary Worker"), /*#__PURE__*/React.createElement("p", null, get(referral, 'primaryWorker.full_name'))), /*#__PURE__*/React.createElement("div", {
      className: "col-span-3 mt-16 p-2"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "uppercase font-semibold mb-1 text-sm text-text-blue"
    }, "Attached Documents"), !isEmpty(get(referral, 'attachedDocuments')) && /*#__PURE__*/React.createElement(DocumentsListView, {
      documents: get(referral, 'attachedDocuments')
    }), !isEmpty(get(referral, 'attachments')) && /*#__PURE__*/React.createElement("div", {
      className: "file-upload-dropzone mb-3 mt-5"
    }, /*#__PURE__*/React.createElement(FilePreviewWrapper, {
      uploadedFiles: get(referral, 'attachments')
    })), isEmpty(get(referral, 'attachments')) && isEmpty(get(referral, 'attachedDocuments')) && /*#__PURE__*/React.createElement("p", {
      className: "italic"
    }, "No Items")), /*#__PURE__*/React.createElement("div", {
      className: "col-span-3 bg-light-pale-blue rounded mt-6 p-6 flex"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "IconExclamationCircle",
      color: "#182A44",
      className: "mt-px mr-4"
    }), /*#__PURE__*/React.createElement("p", null, READY_TO_SUMBIT_INFO_TEXT))))) : null);
  }), !isEmpty(referrals) && /*#__PURE__*/React.createElement("div", {
    className: "pb-6"
  }, /*#__PURE__*/React.createElement(NavButtons, {
    onBackClick: function onBackClick() {
      return navigate(-1);
    },
    onForwardClick: handleSubmit,
    onSaveDraftReferral: handleSaveDraftReferral,
    primaryLabel: "Confirm & Submit",
    hideSaveDraftLink: get(fieldsConfig, 'hideSaveDraftLink'),
    hasOffPlatformReferrals: hasOffPlatformReferrals(referrals),
    disabled: disableSubmit,
    isForwardReferralPath: isForwardReferralPath
  })))));
}
//# sourceMappingURL=Review.js.map